import { NavLink, Outlet, useLocation } from 'react-router-dom';
import {
  ChartBarIcon,
  BeakerIcon,
  CircleStackIcon,
  DocumentMagnifyingGlassIcon,
} from '@heroicons/react/24/outline';
import { useGeoBrowseContext } from '../context/GeoBrowseContext';
import SignificancePanel from './SignificancePanel';
import styles from '../GeoBrowse.module.css';

const NAV_ITEMS = [
  { id: 'diseases', to: '/geo-browse/diseases', label: 'Diseases', Icon: ChartBarIcon, useStudiesList: false },
  { id: 'genes', to: '/geo-browse/genes', label: 'Genes', Icon: CircleStackIcon, useStudiesList: false },
  { id: 'gene-details', to: '/geo-browse/gene-detail', label: 'Gene Details', Icon: DocumentMagnifyingGlassIcon, useStudiesList: false },
  { id: 'studies', to: '/geo-browse/studies', label: 'Studies', Icon: BeakerIcon, useStudiesList: true },
];

function isNavActive(itemId: string, pathname: string): boolean {
  if (itemId === 'diseases') {
    return pathname.includes('/diseases');
  }
  if (itemId === 'genes') {
    return pathname.startsWith('/geo-browse/genes');
  }
  if (itemId === 'gene-details') {
    return pathname.startsWith('/geo-browse/gene-detail');
  }
  if (itemId === 'studies') {
    return pathname.startsWith('/geo-browse/studies');
  }
  return false;
}

export default function GeoBrowseLayout() {
  const { pathname } = useLocation();
  const { buildPathWithThresholds, buildStudiesListPath } = useGeoBrowseContext();

  return (
    <div className={styles.page}>
      <aside className={styles.sidebar}>
        <div className={styles.sidebarBrand}>
          <ChartBarIcon className={styles.sidebarBrandIcon} aria-hidden />
          ExpressNET
        </div>
        <nav className={styles.sidebarNav} aria-label="ExpressNET sections">
          {NAV_ITEMS.map(item => {
            const active = isNavActive(item.id, pathname);
            const to = item.useStudiesList
              ? buildStudiesListPath()
              : buildPathWithThresholds(item.to);
            return (
              <NavLink
                key={item.id}
                to={to}
                className={`${styles.sidebarLink} ${active ? styles.sidebarLinkActive : ''}`}
              >
                <item.Icon className={styles.sidebarLinkIcon} aria-hidden />
                {item.label}
              </NavLink>
            );
          })}
        </nav>
      </aside>

      <div className={styles.main}>
        <div className={styles.mainTop}>
          <SignificancePanel />
        </div>
        <main className={styles.content}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
